import connect from 'components/Shared/connect';
import styles from './summary.scss';
import base from './styles.scss';
import { IconCheckmark } from 'components/Shared/Icon';
import Price from 'components/Shared/Price';
import { Button } from 'components/Button';
import { rm, hasElements } from 'utils';
import { ICart } from 'models/ICart';
import { filterCharges } from 'views/CheckoutPage/selector';
import { SiteMode } from 'models/SiteMode';
import { LoadingStatus } from 'models/LoadingStatus';
import { Text } from 'components/Shared/Loader';
import { getQaDataAttr } from '@bygghemmait/utilities';

interface OwnProps {
  url: string;
}

type CartPick = Pick<
  ICart,
  'cartCharges' | 'totalLineAmount' | 'totalLineAmountIncludingCharges' | 'lowestPartPaymentAmount'
>;
interface MergedProps extends OwnProps, CartPick {
  loading: boolean;
  isB2b: boolean;
}

const TEXT_LOADING_STYLE = {
  height: '2.4rem'
};

const _Summary = ({
  url,
  cartCharges,
  totalLineAmount,
  totalLineAmountIncludingCharges,
  lowestPartPaymentAmount,
  loading,
  isB2b
}: MergedProps) => {
  const charges = cartCharges.filter(filterCharges);
  const showCharges = hasElements(charges);
  const totalPrice = showCharges ? totalLineAmountIncludingCharges : totalLineAmount;

  return (
    <div className={styles.summary}>
      <div className={styles.usps}>
        <ul>
          <li>
            <IconCheckmark className={styles.icon} size="small" />
            {rm('basket_usp_no_account')}
          </li>
          <li>
            <IconCheckmark className={styles.icon} size="small" />
            {rm('basket_usp_fast')}
          </li>
          {!isB2b && lowestPartPaymentAmount > 0 && (
            <li>
              <IconCheckmark className={styles.icon} size="small" />
              {rm('product_price_partpayment', lowestPartPaymentAmount)}{' '}
            </li>
          )}
        </ul>
      </div>
      <div className={styles.charges}>
        {charges.map(charge => (
          <Text
            style={TEXT_LOADING_STYLE}
            loading={loading}
            key={charge.id}
            className={styles.charge}
          >
            <span>{charge.description}</span>
            <Price price={charge.amount} />
          </Text>
        ))}
        <Text style={TEXT_LOADING_STYLE} loading={loading} className={styles.charge}>
          <span className={styles.total}>
            {rm(isB2b ? 'checkout_total_excluding_vat' : 'checkout_total')}
          </span>
          <Price className={styles.totalPrice} price={totalPrice} appearance="discount" />
        </Text>
        <Button
          textTransform="uppercase"
          href={url}
          appearance="tertiary"
          className={base.checkoutButton}
          {...getQaDataAttr('go-to-checkout-button')}
        >
          {rm('shared_minibasket_navigation_next')}
        </Button>
      </div>
    </div>
  );
};

export const Summary = connect<MergedProps, OwnProps>(state => ({
  totalLineAmountIncludingCharges: state.cart.totalLineAmountIncludingCharges,
  totalLineAmount: state.cart.totalLineAmount,
  lowestPartPaymentAmount: state.cart.lowestPartPaymentAmount,
  cartCharges: state.cart.cartCharges,
  isB2b: state.appShell.siteMode === SiteMode.Company,
  loading: state.cart.status === LoadingStatus.Fetching
}))(_Summary);
